import { CraAction, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Audit Actions`;
const sharedProps: Pick<LocDef, 'htmlAllowed' | 'shared' | 'feature'> = {
	htmlAllowed: false,
	shared: false,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
};

type SPCraActionEnumLoc =
	| 'SPCraActionEnumClose'
	| 'SPCraActionEnumNoAction'
	| 'SPCraActionEnumPlaceOnHold'
	| 'SPCraActionEnumReleaseHold';
type CPCraActionEnumLoc =
	| 'CPCraActionEnumClose'
	| 'CPCraActionEnumNoAction'
	| 'CPCraActionEnuPlaceOnHold'
	| 'CPCraActionEnumReleaseHold';

export const spCraActionEnumLocs: LocDefs<SPCraActionEnumLoc> = {
	SPCraActionEnumClose: {
		defaultValue: 'Close',
		displayPath: `${dpRoot}|${CraAction.Close}`,
		description: `Audit action: '${CraAction.Close}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
	SPCraActionEnumNoAction: {
		defaultValue: 'No Action',
		displayPath: `${dpRoot}|${CraAction.NoAction}`,
		description: `Audit action: '${CraAction.NoAction}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
	SPCraActionEnumPlaceOnHold: {
		defaultValue: 'Place on Hold',
		displayPath: `${dpRoot}|${CraAction.PlaceOnHold}`,
		description: `Audit action: '${CraAction.PlaceOnHold}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
	SPCraActionEnumReleaseHold: {
		defaultValue: 'Release Hold',
		displayPath: `${dpRoot}|${CraAction.ReleaseHold}`,
		description: `Audit action: '${CraAction.ReleaseHold}'`,
		displayType: 'Content',
		portal: 'SP',
		...sharedProps,
	},
};

export const cpCraActionEnumLocs: LocDefs<CPCraActionEnumLoc> = {
	CPCraActionEnumClose: {
		defaultValue: 'Close',
		displayPath: `${dpRoot}|${CraAction.Close}`,
		description: `Audit action: '${CraAction.Close}'`,
		displayType: 'Content',
		portal: 'CP',
		...sharedProps,
	},
	CPCraActionEnumNoAction: {
		defaultValue: 'No Action',
		displayPath: `${dpRoot}|${CraAction.NoAction}`,
		description: `Audit action: '${CraAction.NoAction}'`,
		displayType: 'Content',
		portal: 'CP',
		...sharedProps,
	},
	CPCraActionEnuPlaceOnHold: {
		defaultValue: 'Place on Hold',
		displayPath: `${dpRoot}|${CraAction.PlaceOnHold}`,
		description: `Audit action: '${CraAction.PlaceOnHold}'`,
		displayType: 'Content',
		portal: 'CP',
		...sharedProps,
	},
	CPCraActionEnumReleaseHold: {
		defaultValue: 'Release Hold',
		displayPath: `${dpRoot}|${CraAction.ReleaseHold}`,
		description: `Audit action: '${CraAction.ReleaseHold}'`,
		displayType: 'Content',
		portal: 'CP',
		...sharedProps,
	},
};

export type CPCraActionEnumLocType = LocMap<CPCraActionEnumLoc>;
export type SPCraActionEnumLocType = LocMap<SPCraActionEnumLoc>;

export const spCraActionKeys: { [key in CraAction]: keyof SPCraActionEnumLocType } = {
	[CraAction.Close]: 'SPCraActionEnumClose',
	[CraAction.NoAction]: 'SPCraActionEnumNoAction',
	[CraAction.PlaceOnHold]: 'SPCraActionEnumPlaceOnHold',
	[CraAction.ReleaseHold]: 'SPCraActionEnumReleaseHold',
};

export const cpCraActionKeys: { [key in CraAction]: keyof CPCraActionEnumLocType } = {
	[CraAction.Close]: 'CPCraActionEnumClose',
	[CraAction.NoAction]: 'CPCraActionEnumNoAction',
	[CraAction.PlaceOnHold]: 'CPCraActionEnuPlaceOnHold',
	[CraAction.ReleaseHold]: 'CPCraActionEnumReleaseHold',
};
